var React = require('react');

function ContentEnvelopeHollow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1117.5,750H30c-15,0-30-11.2-30-30V26.2C3.8,11.2,15,0,30,0h1087.5c15,0,30,11.2,30,30v693.8c0,15-15,26.2-30,26.2ZM60,693.8h1031.2V56.2H60v637.5Z","key":0}),React.createElement("path",{"d":"M742,340.3l392.9,359.4-38,41.5-392.9-359.4,38-41.5Z","key":1}),React.createElement("path",{"d":"M406,340.3l38,41.5L51.1,741.2l-38-41.5,392.9-359.4Z","key":2}),React.createElement("path",{"d":"M573.7,517.5c-7.5,0-11.2-3.8-18.8-7.5L14.9,48.8C3.7,41.2,0,30,3.7,18.8S18.7,0,29.9,0h1083.8c11.2,0,22.5,7.5,26.2,18.8s0,22.5-7.5,30l-540,461.2c-7.5,7.5-11.2,7.5-18.8,7.5h0ZM108.7,56.2l465,397.5L1038.7,56.2H108.7Z","key":3})]);
}

ContentEnvelopeHollow.defaultProps = {"version":"1.1","viewBox":"0 0 1147.5 750"};

module.exports = ContentEnvelopeHollow;

ContentEnvelopeHollow.default = ContentEnvelopeHollow;
